export const ThemeManager = {
    getTheme(){
        return localStorage.getItem('theme') ?? 'light'
    },
    setTheme(theme){
        localStorage.setItem('theme', theme)
            document.documentElement.classList.toggle('dark', theme === 'dark');
    },
    toggleTheme(){
        const currentTheme = this.getTheme()
        const next = currentTheme === 'dark' ? 'light' : 'dark'
        this.setTheme(next)
        return next
    }
}